import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
  Alert,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchProcessSAYT,
  fetchProcInstancesDetailed,
  getAllTaskNames,
  cancelProcessInstance,
  getFilterOptions,
} from 'store/appTrack/actions';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import TableCell from './components/TableCell';
import moment from 'moment';
import { StatusTag } from 'components';
import { companyLegalTypeList, isBeneficiary, isAuditor } from 'utils';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import { getSystemLocales, clearForm } from 'store/forms/actions';
import { setActiveFormId } from 'store/activeForm/actions';
import { checkUser, getUser, getTaxisData } from 'store/user/actions';
import { ReactComponent as CancelWarningIcon } from '../../../assets/icons/cancel_warning_icon.svg';
import { getFullDateTimeWithSeconds, getFullDateTime } from 'utils/helpers';
import { kadArray } from 'utils/kadArray';
import { handleCheckUniqueness } from 'utils';
import {
  checkUniqueness,
  updateFormField,
  submitValidation,
} from 'store/forms/actions';
import { SubmitModal } from '../../../components/layout/components';
import { handleAuditorSubmit, auditorOutcomes, handleCommitteeSubmit, committeeOutcomes } from '../../../utils';


const AppTrackPage1 = ({ disabled }) => {
  const viewMode = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  //const saytOptions = useSelector(state => state.appTrack.sayt);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const results = useSelector(state => state.appTrack.variables);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const sayt = useSelector(state => state.appTrack.sayt);
  const filterOptions = useSelector(state => state.appTrack.filterOptions);
  const isKTP = user.groups?.map(item => item.name).includes('KTP');
  const [cancelModal, setCancelModal] = useState(false);
  const checkUniquenessCreate = useSelector(
    state => state.forms.checkUniquenessCreate
  );

  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);

  const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false);
  const [modalOutcome, setModalOutcome] = useState(null);

  const rejectAuditorReason = useSelector(state => state.forms?.carrier?.rejectAuditorReason);
  const rejectAuditorMessage = useSelector(state => state.forms?.carrier?.rejectAuditorMessage);
  const rejectCommitteeReason = useSelector(state => state.forms?.carrier?.rejectCommitteeReason);
  const rejectCommitteeMessage = useSelector(state => state.forms?.carrier?.rejectCommitteeMessage);


  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    dispatch(getSystemLocales(storedLanguage));
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(clearForm());
    dispatch(fetchProcInstancesDetailed());
    dispatch(getAllTaskNames());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (groups) {
      !isBeneficiary(groups) && dispatch(getFilterOptions());
    }
  }, [groups]);

  useEffect(() => {
    if (user?.taxis_data?.afm) {
      handleCheckUniqueness({
        user,
        dispatch,
        submitValidation,
        // checkUniqueness,
      }).then(res => {
        const reasons = {
          case: 'checkUniqueness',
          acceptable: true, //res.acceptable,
          // responseCode: res.responseCode, //"901",//res.responseCode,
          isActive: true, //user?.taxis_data?.deactivationFlag === "1" ? true : false,
          isAcceptedRegDate: true, //moment(user?.taxis_data?.registDate).utc().format("YYYY-MM-DD") <= '2024-06-30',
        };
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'canCreate',
            value: res.acceptable,
          })
        );
        dispatch(
          updateFormField({
            group: 'checkUniquenessCreate',
            key: 'isAcceptedUserNp',
            value:
              !isNil(user?.taxis_data?.iniFlag) &&
              user?.taxis_data?.iniFlag === '2'
                ? true
                : false,
          })
        );
      });
    }
  }, [user?.taxis_data]);

  const dateFormat = 'DD/MM/YYYY';
  const marks = {
    0: '0 €',
    2000: '2.000 €',
  };
  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

    // Open modal gia ton auditor
const handleOpenSubmitModal = (outcome) => {
  setModalOutcome(outcome);
  setIsSubmitModalVisible(true);
};

// function to handle the actual submission
const handleModalSubmit = async () => {
        if (modalOutcome === auditorOutcomes.approveAuditor || modalOutcome === auditorOutcomes.rejectAuditor) {
            await handleAuditorSubmit({
                outcome: modalOutcome,
                dispatch,
                procInstId: selectedProcId,
                navigate,
                rejectAuditorReason,
                rejectAuditorMessage,
            });
            setIsSubmitModalVisible(false);
        } else if (modalOutcome === committeeOutcomes.approveCommittee || modalOutcome === committeeOutcomes.rejectCommittee) {
            // Handle committee submissions
            await handleCommitteeSubmit({
                outcome: modalOutcome,
                dispatch,
                procInstId: selectedProcId,
                navigate,
                rejectCommitteeReason,
                rejectCommitteeMessage,
            });
            setIsSubmitModalVisible(false);
        }
    };

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const cancelProcess = selectedProcId => {
    dispatch(cancelProcessInstance(selectedProcId));
    setCancelModal(false);
    window.location.reload();
  };

  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: record => {
      return {
        disabled:
          record.applStatus !== 'AS_1G' && record.applStatus !== 'AS_6B',
      };
    },
  };

  useEffect(() => {
    if (!isEmpty(detailedPayload) && userStatus)
      dispatch(fetchProcInstancesDetailed(detailedPayload));
  }, [detailedPayload]);

  const formatter = new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  const saytOptionsTmp = [];

  const handleSAYT = value => {
    if (value.length >= 3) {
      dispatch(fetchProcessSAYT(value));
    }
  };

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name != 'limitExceeded') {
          if (key?.name == 'abiVat' || key?.name == 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name == 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name == 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          }
          const uniqueValues = new Set();

          for (let value of key?.values) {
            if (!uniqueValues.has(value.value)) {
              uniqueValues.add(value.value);
              opt.options.push(renderItem(value.value));
            }
          }
          saytOptionsTmp.push(opt);
        }
        setSaytOptions(saytOptionsTmp);
      });
    } else {
      setSaytOptions([]);
    }
  }, [sayt]);

  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // detailedPayloadTmp["saytKey"] = value;
    // setDetailedPayload(detailedPayloadTmp);
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length == 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      // delete detailedPayloadTmp.saytKey;
      // setDetailedPayload(detailedPayloadTmp);
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // console.log(detailedPayloadTmp, value)
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('activeTaskName'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'activeTaskName') {
            return { ...obj, value: [value] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'activeTaskName',
          type: 'STRING_LIST',
          value: [value],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'activeTaskName'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onFilterChange = (value, qualifier, type) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes(qualifier))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === qualifier) {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: qualifier,
          type: type,
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== qualifier
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onDateRangeChange = (value, dateString, placeholder) => {
    console.log({ value, dateString, placeholder });
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === placeholder) {
            return { ...obj, from: dateString[0], to: dateString[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: placeholder,
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== placeholder
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSliderChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(value[0]) && !isEmpty(value[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'totalValue') {
            return { ...obj, from: value[0], to: value[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'totalValue',
          type: 'RANGE_VALUE',
          from: value[0],
          to: value[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'totalValue'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const id = open ? 'simple-popover' : 'simple-popover';

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  const onMoreClick = (id, b_key) => event => {
    setSelectedProcId(id);
    dispatch(setActiveFormId(id));
    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const getStatusTag = status => {
    switch (status) {
      case 'request.status.auditApplicationSecond':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_AUDITAPPLICATIONSECOND
        );
      case 'request.status.auditApplicationFirst':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_AUDITAPPLICATIONFIRST
        );
      case 'request.status.submitApplication':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_SUBMITAPPLICATION
        );
      case 'request.status.payment':
        return getLocalString(locales, localNames.REQUEST_STATUS_PAYMENT);
      case 'request.status.rejectApplication':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_REJECTAPPLICATION
        );
      case 'request.page.returnButton':
        return getLocalString(locales, localNames.REQUEST_PAGE_RETURN);
      case 'task.name.program_implementation':
        return getLocalString(
          locales,
          localNames.REQUEST_STATUS_PROGRAMIMPLEMENTATION
        );
      case 'task.name.application_withdrawal':
        return getLocalString(
          locales, 
          localNames.TASK_NAME_APPLICATION_WITHDRAWAL
        );

      default:
        return null;
    }
  };

  const beneficiaryColumns = [
    {
      title: 'Αριθμός Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      width: 100,
      fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ.',
      dataIndex: 'abiVat',
      key: 'abiVat',
      sorter: {
        compare: (a, b) => Number(a.abiVat) - Number(b.abiVat),
      },
      render: (text, record) => (
        <TableCell id={`abiVat-cell-${record.businessKey}`} text={text} />
      ),
      width: 100,
      // width: 71,
    },
    {
      title: 'Επωνυμία',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text, record) => {
        return (
          <TableCell
            id={`companyName-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName === 'string'
          ) {
            return a.companyName.localeCompare(b.companyName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.companyName !== 'string' &&
            typeof b.companyName === 'string'
          ) {
            return -1; // a comes first if b has valid companyName but a doesn't
          }
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName !== 'string'
          ) {
            return 1; // b comes first if a has valid companyName but b doesn't
          }
          return 0; // If neither a nor b have valid companyName, treat them as equal
        },
      },
      width: 260,
      // className: "col-3",
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.activeTaskName === 'string' &&
            typeof b.activeTaskName === 'string'
          ) {
            return a.activeTaskName.localeCompare(b.activeTaskName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.activeTaskName !== 'string' &&
            typeof b.activeTaskName === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof a.activeTaskName === 'string' &&
            typeof b.activeTaskName !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
      width: 160,
      // className: "col-2",
    },
    // {
    //   title: "Νομική Μορφή",
    //   key: "companyLegalType",
    //   sorter: {
    //     compare: (a, b) => {
    //       // Check if both properties exist and are strings
    //       if (
    //         typeof a.companyLegalType === "string" &&
    //         typeof b.companyLegalType === "string"
    //       ) {
    //         return a.companyLegalType.localeCompare(b.companyLegalType);
    //       }

    //       // Handle cases where one or both properties don't exist or aren't strings
    //       if (
    //         typeof a.companyLegalType !== "string" &&
    //         typeof b.companyLegalType === "string"
    //       ) {
    //         return -1; // a comes first if b has valid companyLegalType but a doesn't
    //       }
    //       if (
    //         typeof a.companyLegalType === "string" &&
    //         typeof b.companyLegalType !== "string"
    //       ) {
    //         return 1; // b comes first if a has valid companyLegalType but b doesn't
    //       }
    //       return 0; // If neither a nor b have valid companyLegalType, treat them as equal
    //     },
    //   },
    //   dataIndex: "companyLegalType",
    //   // className: "col-2",
    //   render: (text) => <TableCell text={text} />,
    //   width: 200,
    // },
    {
      title: 'Υποβολή',
      dataIndex: 'submitApplicationDate',
      key: 'submitApplicationDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`submissionDate-cell-${record.businessKey}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submitApplicationDate && b.submitApplicationDate) {
            return (
              new Date(a.submitApplicationDate) -
              new Date(b.submitApplicationDate)
            );
          } else if (!a.submitApplicationDate && b.submitApplicationDate) {
            return -1;
          } else if (a.submitApplicationDate && !b.submitApplicationDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      // width: 120,
    },
    // {
    //   title: 'Δείκτης Αξιολόγησης',
    //   key: 'indicator',
    //   // className: "col-6",
    //   dataIndex: 'indicator',
    //   render: text => {
    //     return <TableCell text={text} />;
    //   },
    //   sorter: {
    //     compare: (a, b) => a.indicator - b.indicator,
    //   },
    //   // width: 129,
    // },
    {
      title: 'Έγκριση Αξιολογητή',
      key: 'auditorSubmitDate',
      sorter: (a, b) =>
        moment(a.auditorSubmitDate).unix() - moment(b.auditorSubmitDate).unix(),
      // className: props.isBeneficiary || props.isMinistry || props.isAdmin? "col-4" : "hidden",
      dataIndex: 'auditorSubmitDate',
      render: date => getFullDateTime(date),
      //width: 120,
    },
    {
      title: 'Ένταξη',
      key: 'committeeApprovalDate',
      sorter: (a, b) =>
        moment(a.committeeApprovalDate).unix() -
        moment(b.committeeApprovalDate).unix(),
      // className: props.isBeneficiary || props.isMinistry || props.isAdmin? "col-4" : "hidden",
      dataIndex: 'committeeApprovalDate',
      render: date => getFullDateTime(date),
      //width: 120,
    },
    {
      title: 'Απένταξη',
      key: 'applicationCommitteeRejectedDate',
      sorter: (a, b) =>
        moment(a.applicationCommitteeRejectedDate).unix() -
        moment(b.applicationCommitteeRejectedDate).unix(),
      // className: props.isBeneficiary || props.isMinistry || props.isAdmin? "col-4" : "hidden",
      dataIndex: 'applicationCommitteeRejectedDate',
      render: date => getFullDateTime(date),
      // width: 120,
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const [sortedUp, setSortedUp] = useState(false);
  const [sortedDown, setSortedDown] = useState(true);

  return loadingTaxis || loadingLocales ? (
    <main>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
      >
        <Spin size="large" />
      </div>
    </main>
  ) : (
    <main>
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModal}
        className={`custom-modal`}
        onCancel={() => setCancelModal(false)}
        onOk={() => setCancelModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Ακύρωση Αίτησης</h3>
          <p>
            Είστε βέβαιος/-η ότι επιθυμείτε να κάνετε οριστική ακύρωση της
            αίτησης;
          </p>
          <p>Η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <div
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModal(false)}
          >
            Επιστροφή
          </div>
          <div
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcess(selectedProcId)}
            className="btn-assign cancel"
          >
            Ακύρωση
          </div>
        </div>
      </Modal>

      <div>
        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <ActionList
              open={setOpen}
              id={selectedProcId}
              payload={detailedPayload}
              setCancelModal={setCancelModal}
              onOpenSubmitModal={handleOpenSubmitModal}
            />
          </Popover>
        </div>

        <div style={{ marginTop: '30px', marginBottom: '21px' }}>
          {privileges?.includes('CanRenderSAYT') && !isBeneficiary(groups) && (
            <AutoComplete
              id="search-autocomplete"
              popupClassName="certain-category-search-dropdown"
              dropdownMatchSelectWidth={500}
              style={{ width: '100%' }}
              options={saytOptions}
              onSearch={handleSAYT}
              onSelect={onSAYTSelect}
              onChange={onSAYTChange}
              defaultValue={detailedPayload?.saytKey}
            >
              <Input.Search
                id="autocomplete-search-input"
                onSearch={onSAYTSearch}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                // placeholder={getLocalString(
                //   locales,
                //   isKTP ? localNames.HOME_PAGE_SEARCHKTP :
                //   isBeneficiary(groups) ? localNames.HOME_PAGE_SEARCHNP :
                //   ''
                // )}
                placeholder="Αναζήτηση με Αρ. Αίτησης, ΑΦΜ, Επωνυμία"
                enterButton
              />
            </AutoComplete>
          )}

          {privileges?.includes('CanRenderAppFilters') && (
            <div>
              <Tooltip placement="right" title="Expanded Filters">
                <Space
                  id="filters-toggle-button"
                  onClick={() => toggleFilters()}
                  onMouseEnter={() => overFilter()}
                  onMouseLeave={() => outFilter()}
                  className="filterButton mt-3"
                >
                  {filterImg}
                  <span className={filterText}>
                    {getLocalString(
                      locales,
                      localNames.HOME_PAGE_FILTERSBUTTON
                    )}
                  </span>
                </Space>
              </Tooltip>

              {isFiltersVisible && (
                <div className="filtersContainer">
                  <div className="filters-wrapper">
                    <div style={{ flex: '1' }}>
                      <Select
                        id="select-application-status"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        style={{ width: '100%' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        showSearch
                        allowClear={true}
                        placeholder={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_FILTERS_STATUS
                          ) || 'Status'
                        }
                        optionFilterProp="children"
                        onChange={onStatusChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {taskNames?.map(item => (
                          <Option
                            id={`status-${item.name}-option`}
                            key={item.name}
                            value={item.name}
                          >
                            {getLocalString(locales, item.name)}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div style={{ flex: '1' }}>
                      <RangePicker
                        id="application-results-date-range-picker-from"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            rangePlaceholder: [
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATEFROM
                              ),
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATETO
                              ),
                            ],
                          },
                        }}
                        format={dateFormat}
                        suffixIcon={<CalendarIcon />}
                        allowEmpty={[true, true]}
                        onCalendarChange={(dates, dateStrings) =>
                          onDateRangeChange(
                            dates,
                            dateStrings,
                            'submitApplicationDate'
                          )
                        }
                        className="input-filter"
                        style={{ width: '100%', height: 'unset !important' }}
                      />
                    </div>
                    <div style={{ flex: '1' }}>
                      <RangePicker
                        id="application-results-date-range-picker-from"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            rangePlaceholder: [
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_AUDITOR_SUBMITDATEFROM
                              ),
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_AUDITOR_SUBMITDATETO
                              ),
                            ],
                          },
                        }}
                        format={dateFormat}
                        suffixIcon={<CalendarIcon />}
                        allowEmpty={[true, true]}
                        onCalendarChange={(dates, dateStrings) =>
                          onDateRangeChange(
                            dates,
                            dateStrings,
                            'auditorSubmitDate'
                          )
                        }
                        className="input-filter"
                        style={{ width: '100%', height: 'unset !important' }}
                      />
                    </div>
                  </div>
                  <div className="filters-wrapper">
                    <div style={{ flex: '1' }}>
                      <Select
                        id="prefecture-filter-select"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        style={{ width: '100%' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        showSearch
                        allowClear={true}
                        placeholder="Νομός"
                        optionFilterProp="children"
                        defaultValue={detailedPayload.prefecture}
                        onChange={e =>
                          onFilterChange(e, 'abiPerfecture', 'STRING_VALUE')
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {filterOptions?.prefectures.map((i, index) => (
                          <Option id={`prefecture-option-${i}`} value={i}>
                            {i}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div style={{ flex: '1' }}>
                      <Select
                        id="district-filter-select"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        style={{ width: '100%' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        showSearch
                        allowClear={true}
                        placeholder="Περιοχή"
                        optionFilterProp="children"
                        defaultValue={detailedPayload.prefecture}
                        onChange={e =>
                          onFilterChange(e, 'abiDistrict', 'STRING_VALUE')
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {filterOptions?.districts.map((i, index) => (
                          <Option id={`district-option-${i}`} value={i}>
                            {i}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div style={{ flex: '1' }}></div>
                  </div>
                </div>
              )}
            </div>
          )}

          {isBeneficiary(groups) && (
            <Alert
              className="beneficiary-banner"
              message="Ενημέρωση για Υποβολή Αιτήσεων"
              description={
                <div>
                  Η υποβολή αιτήσεων στο Πρόγραμμα ολοκληρώθηκε στις 30 Ιουνίου
                  2025 σύμφωνα με σχετική ανακοίνωση του Υπουργείου
                  Περιβάλλοντος και Ενέργειας (
                  <a
                    href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-sto-programma-proothisi-tis-energeiakis-apodosis-stis-dimotikes-epicheiriseis-ydrefsis-kai-apochetefsis-2/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Παράταση υποβολής αιτήσεων στο πρόγραμμα «Προώθηση της
                    ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης
                    και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας
                  </a>
                  )
                </div>
              }
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              closable={false}
            />
          )}

          {(privileges?.includes('CanRenderSAYT') ||
            privileges?.includes('CanRenderAppFilters')) &&
            !isBeneficiary(groups) && <Divider className="filter-divider" />}
          {loadingPage && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin
                id="apptrack-application-results-table-spinner"
                size="default"
              />
            </div>
          )}
          {!loadingPage && (
            <Row gutter={32}>
              <Col span={24}>
                {!isEmpty(results) &&
                  (!isBeneficiary(groups) ||
                    (isBeneficiary(groups) &&
                      checkUniquenessCreate?.isAcceptedUserNp)) && (
                    <div>
                      <Table
                        scroll={{ x: true }}
                        id="apptrack-application-results-table"
                        className="results-table"
                        dataSource={results}
                        columns={beneficiaryColumns}
                        rowKey="id"
                        pagination={{
                          showSizeChanger: false,
                          showTitle: false,
                          onChange: handlePageChange,
                        }}
                      />
                    </div>
                  )}

                {isEmpty(results) &&
                  (!isBeneficiary(groups) ||
                    (isBeneficiary(groups) &&
                      checkUniquenessCreate?.isAcceptedUserNp)) && (
                    // checkUniquenessCreate?.canCreate && checkUniquenessCreate?.isAcceptedUserNp (
                    <NoResults
                      id="apptrack-application-results-no-results"
                      description={'Δε βρέθηκαν αποτελέσματα'}
                      subDescription={''}
                    />
                  )}
                  {isSubmitModalVisible && (
                  <SubmitModal
                    isVisible={isSubmitModalVisible}
                    setIsVisible={setIsSubmitModalVisible}
                    handleSubmit={handleModalSubmit}
                    submitDisabled={false}
                    formKey="auditor"
                    outcome={modalOutcome}
                    businessKey={selectedProcId}
                  />
                )}

                {isBeneficiary(groups) &&
                  !isNil(checkUniquenessCreate) &&
                  !checkUniquenessCreate?.isAcceptedUserNp && (
                    <NoResults
                      id="apptrack-application-results-no-results"
                      description={
                        <div>
                          {!checkUniquenessCreate?.isAcceptedUserNp && (
                            <p>
                              Δεν έχετε τη δυνατότητα να υποβάλετε αίτηση, καθώς
                              δεν αποτελείτε νομική οντότητα.
                            </p>
                          )}
                        </div>
                      }
                      subDescription={''}
                    />
                  )}
              </Col>
            </Row>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppTrackPage1;
